import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import api from "../api/axios";

function CommunityCenterBookingList() {

    const navigate = useNavigate();

    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);

    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");


    // ==========================================
    // LOAD BOOKINGS
    // ==========================================

    useEffect(() => {
        loadBookings();
    }, []);


    const loadBookings = async () => {

        try {

            setLoading(true);

            const response =
                await api.get(
                    "/CommunityCenterBooking/GetAll"
                );

            setBookings(
                Array.isArray(response.data)
                    ? response.data
                    : []
            );

        } catch (error) {

            console.error(error);

            Swal.fire(
                "Error",
                error.response?.data?.message ||
                "Booking list load nahi ho saki.",
                "error"
            );

        } finally {

            setLoading(false);
        }
    };


    // ==========================================
    // FORMAT DATE
    // ==========================================

    const formatDate = (date) => {

        if (!date) return "-";

        return new Date(date).toLocaleDateString(
            "en-GB"
        );
    };


    // ==========================================
    // CANCEL BOOKING
    // ==========================================

    const cancelBooking = async (id) => {

        const result = await Swal.fire({

            title: "Cancel Booking?",

            text: "Are you sure you want to cancel this booking?",

            icon: "warning",

            showCancelButton: true,

            confirmButtonText: "Yes, Cancel",

            cancelButtonText: "No"
        });


        if (!result.isConfirmed) {
            return;
        }


        try {

            const userId =
                localStorage.getItem("userId");


            await api.put(
                `/CommunityCenterBooking/Cancel/${id}`,
                userId
                    ? Number(userId)
                    : null
            );


            Swal.fire(
                "Cancelled",
                "Booking cancelled successfully.",
                "success"
            );


            loadBookings();

        } catch (error) {

            console.error(error);

            Swal.fire(
                "Error",
                error.response?.data?.message ||
                "Booking cancel nahi ho saki.",
                "error"
            );
        }
    };


    // ==========================================
    // FILTER
    // ==========================================

    const filteredBookings =
        bookings.filter((item) => {

            const searchText =
                search.toLowerCase().trim();


            const matchesSearch =
                !searchText ||
                String(item.bookingId)
                    .toLowerCase()
                    .includes(searchText) ||

                item.communityCenterName
                    ?.toLowerCase()
                    .includes(searchText) ||

                item.applicantName
                    ?.toLowerCase()
                    .includes(searchText) ||

                item.mobileNumber
                    ?.toLowerCase()
                    .includes(searchText);


            const matchesStatus =
                !status ||
                item.bookingStatus === status;


            return (
                matchesSearch &&
                matchesStatus
            );
        });


    // ==========================================
    // STATUS BADGE
    // ==========================================

    const getStatusBadge = (status) => {

        switch (status) {

            case "Approved":
                return "bg-success";

            case "Pending":
                return "bg-warning text-dark";

            case "Cancelled":
                return "bg-danger";

            case "Rejected":
                return "bg-danger";

            case "Completed":
                return "bg-primary";

            default:
                return "bg-secondary";
        }
    };


    // ==========================================
    // PAYMENT BADGE
    // ==========================================

    const getPaymentBadge = (status) => {

        switch (status) {

            case "Paid":
                return "bg-success";

            case "Partial":
                return "bg-warning text-dark";

            case "Failed":
                return "bg-danger";

            default:
                return "bg-secondary";
        }
    };


    // ==========================================
    // LOADING
    // ==========================================

    if (loading) {

        return (

            <div className="text-center p-5">

                <div
                    className="spinner-border text-primary"
                    role="status"
                />

                <p className="mt-2">
                    Loading bookings...
                </p>

            </div>
        );
    }


    return (

        <div className="container-fluid py-3">

            {/* ===================================== */}
            {/* HEADER */}
            {/* ===================================== */}

            <div class="card-header bg-primary text-white">

                <div>

                    <h4 className="mb-1">
                        Community Center Booking List
                    </h4>

                    <small className="text-muted">
                        Manage Community Center bookings
                    </small>

                </div>


                <button
                    type="button"
                    className="btn btn-success"
                    onClick={() =>
                        navigate(
                            "/communitycenterlist"
                        )
                    }
                >
                    <i className="bi bi-plus-circle me-1"></i>
                    New Booking
                </button>

            </div>


            {/* ===================================== */}
            {/* FILTER CARD */}
            {/* ===================================== */}

            <div className="card shadow-sm mb-3">

                <div className="card-body">

                    <div className="row g-2">

                        {/* SEARCH */}

                        <div className="col-md-8">

                            <label className="form-label">
                                Search
                            </label>

                            <input
                                type="text"
                                className="form-control"
                                placeholder="Booking ID, Center Name, Applicant Name or Mobile..."
                                value={search}
                                onChange={(e) =>
                                    setSearch(
                                        e.target.value
                                    )
                                }
                            />

                        </div>


                        {/* STATUS */}

                        <div className="col-md-4">

                            <label className="form-label">
                                Booking Status
                            </label>

                            <select
                                className="form-select"
                                value={status}
                                onChange={(e) =>
                                    setStatus(
                                        e.target.value
                                    )
                                }
                            >

                                <option value="">
                                    All Status
                                </option>

                                <option value="Pending">
                                    Pending
                                </option>

                                <option value="Approved">
                                    Approved
                                </option>

                                <option value="Rejected">
                                    Rejected
                                </option>

                                <option value="Cancelled">
                                    Cancelled
                                </option>

                                <option value="Completed">
                                    Completed
                                </option>

                            </select>

                        </div>

                    </div>

                </div>

            </div>


            {/* ===================================== */}
            {/* SUMMARY */}
            {/* ===================================== */}

            <div className="row mb-3">

                <div className="col-md-3 mb-2">

                    <div className="card shadow-sm">

                        <div className="card-body">

                            <small className="text-muted">
                                Total Bookings
                            </small>

                            <h4 className="mb-0">
                                {bookings.length}
                            </h4>

                        </div>

                    </div>

                </div>


                <div className="col-md-3 mb-2">

                    <div className="card shadow-sm">

                        <div className="card-body">

                            <small className="text-muted">
                                Pending
                            </small>

                            <h4 className="mb-0 text-warning">

                                {
                                    bookings.filter(
                                        x =>
                                            x.bookingStatus ===
                                            "Pending"
                                    ).length
                                }

                            </h4>

                        </div>

                    </div>

                </div>


                <div className="col-md-3 mb-2">

                    <div className="card shadow-sm">

                        <div className="card-body">

                            <small className="text-muted">
                                Approved
                            </small>

                            <h4 className="mb-0 text-success">

                                {
                                    bookings.filter(
                                        x =>
                                            x.bookingStatus ===
                                            "Approved"
                                    ).length
                                }

                            </h4>

                        </div>

                    </div>

                </div>


                <div className="col-md-3 mb-2">

                    <div className="card shadow-sm">

                        <div className="card-body">

                            <small className="text-muted">
                                Cancelled
                            </small>

                            <h4 className="mb-0 text-danger">

                                {
                                    bookings.filter(
                                        x =>
                                            x.bookingStatus ===
                                            "Cancelled"
                                    ).length
                                }

                            </h4>

                        </div>

                    </div>

                </div>

            </div>


            {/* ===================================== */}
            {/* TABLE */}
            {/* ===================================== */}

            <div className="card shadow-sm">

                <div className="card-body p-0">

                    <div className="table-responsive">

                        <table className="table table-bordered table-hover align-middle mb-0">

                            <thead className="table-light">

                                <tr>

                                    <th>
                                        #
                                    </th>

                                    <th>
                                        Booking ID
                                    </th>

                                    <th>
                                        Community Center
                                    </th>

                                    <th>
                                        Applicant
                                    </th>

                                    <th>
                                        Mobile
                                    </th>

                                    <th>
                                        Booking Date
                                    </th>

                                    <th>
                                        Days
                                    </th>

                                    <th className="text-end">
                                        Total Amount
                                    </th>

                                    <th>
                                        Payment
                                    </th>

                                    <th>
                                        Status
                                    </th>

                                    <th
                                        className="text-center"
                                        style={{
                                            minWidth: "150px"
                                        }}
                                    >
                                        Action
                                    </th>

                                </tr>

                            </thead>


                            <tbody>

                                {filteredBookings.length === 0 ? (

                                    <tr>

                                        <td
                                            colSpan="11"
                                            className="text-center py-5 text-muted"
                                        >

                                            <i
                                                className="bi bi-calendar-x"
                                                style={{
                                                    fontSize: "30px"
                                                }}
                                            />

                                            <div className="mt-2">
                                                No bookings found.
                                            </div>

                                        </td>

                                    </tr>

                                ) : (

                                    filteredBookings.map(
                                        (item, index) => (

                                            <tr
                                                key={
                                                    item.bookingId
                                                }
                                            >

                                                {/* INDEX */}

                                                <td>
                                                    {index + 1}
                                                </td>


                                                {/* BOOKING ID */}

                                                <td>

                                                    <strong>
                                                        #
                                                        {
                                                            item.bookingId
                                                        }
                                                    </strong>

                                                </td>


                                                {/* CENTER */}

                                                <td>

                                                    <div className="fw-semibold">

                                                        {
                                                            item.communityCenterName ||
                                                            "-"
                                                        }

                                                    </div>

                                                </td>


                                                {/* APPLICANT */}

                                                <td>

                                                    <div className="fw-semibold">

                                                        {
                                                            item.applicantName ||
                                                            "-"
                                                        }

                                                    </div>

                                                    {item.email && (

                                                        <small className="text-muted">

                                                            {
                                                                item.email
                                                            }

                                                        </small>

                                                    )}

                                                </td>


                                                {/* MOBILE */}

                                                <td>

                                                    {
                                                        item.mobileNumber ||
                                                        "-"
                                                    }

                                                </td>


                                                {/* DATES */}

                                                <td>

                                                    <div>
                                                        <strong>
                                                            {
                                                                formatDate(
                                                                    item.fromDate
                                                                )
                                                            }
                                                        </strong>

                                                        <span className="mx-1">
                                                            -
                                                        </span>

                                                        <strong>
                                                            {
                                                                formatDate(
                                                                    item.toDate
                                                                )
                                                            }
                                                        </strong>
                                                    </div>

                                                </td>


                                                {/* DAYS */}

                                                <td>

                                                    {
                                                        item.numberOfDays
                                                    }

                                                </td>


                                                {/* TOTAL */}

                                                <td className="text-end">

                                                    <strong>
                                                        ₹
                                                        {Number(
                                                            item.totalAmount || 0
                                                        ).toFixed(2)}
                                                    </strong>

                                                </td>


                                                {/* PAYMENT */}

                                                <td>

                                                    <span
                                                        className={`badge ${getPaymentBadge(
                                                            item.paymentStatus
                                                        )}`}
                                                    >
                                                        {
                                                            item.paymentStatus ||
                                                            "Pending"
                                                        }
                                                    </span>

                                                </td>


                                                {/* STATUS */}

                                                <td>

                                                    <span
                                                        className={`badge ${getStatusBadge(
                                                            item.bookingStatus
                                                        )}`}
                                                    >
                                                        {
                                                            item.bookingStatus ||
                                                            "Pending"
                                                        }
                                                    </span>

                                                </td>


                                                {/* ACTION */}

                                                <td>

                                                    <div className="d-flex gap-1 justify-content-center">

                                                        {/* VIEW */}

                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-outline-primary"
                                                            title="View"
                                                            onClick={() =>
                                                                navigate(
                                                                    `/communitycenterbookingdetails/${item.bookingId}`
                                                                )
                                                            }
                                                        >

                                                            <i className="bi bi-eye"></i>

                                                        </button>


                                                        {/* PRINT */}

                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-outline-secondary"
                                                            title="Print"
                                                            onClick={() =>
                                                                navigate(
                                                                    `/communitycenterbookingdetails/${item.bookingId}`
                                                                )
                                                            }
                                                        >

                                                            <i className="bi bi-printer"></i>

                                                        </button>


                                                        {/* CANCEL */}

                                                        {
                                                            item.bookingStatus !==
                                                                "Cancelled" &&
                                                            item.bookingStatus !==
                                                                "Completed" && (

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-danger"
                                                                    title="Cancel"
                                                                    onClick={() =>
                                                                        cancelBooking(
                                                                            item.bookingId
                                                                        )
                                                                    }
                                                                >

                                                                    <i className="bi bi-x-circle"></i>

                                                                </button>

                                                            )
                                                        }

                                                    </div>

                                                </td>

                                            </tr>

                                        )
                                    )

                                )}

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

        </div>
    );
}

export default CommunityCenterBookingList;